import { useMemo } from 'react';

import { ChessStockfishArrow } from '@exports/ChessBoard';
import { SquareName } from '@libs/chess/types';

import { IValuationLine } from '../providers/engines';

function parseUciMove(uci: string): { from: SquareName; to: SquareName } | null {
  if (uci.length < 4) return null;
  const from = uci.slice(0, 2) as SquareName;
  const to = uci.slice(2, 4) as SquareName;
  return { from, to };
}

export function useStockfishArrows(
  valuations: IValuationLine[] | undefined,
  enabled: boolean,
): ChessStockfishArrow[] {
  const key =
    !enabled || !valuations?.length
      ? ''
      : valuations
          .slice(0, 3)
          .map((l) => l?.moves[0] ?? '')
          .concat(valuations[0]?.moves[1] ?? '')
          .join(',');

  return useMemo(() => {
    if (!key) return [];

    const arrows: ChessStockfishArrow[] = [];

    const len = Math.min(valuations!.length, 3);
    for (let i = len - 1; i >= 0; i--) {
      const line = valuations![i];
      const firstMove = line?.moves[0];
      if (!firstMove) continue;

      const parsed = parseUciMove(firstMove);
      if (!parsed) continue;

      if (i === 0) {
        // ответ соперника на первый ход лучшей линии
        const reply = line.moves[1] ? parseUciMove(line.moves[1]) : null;
        if (reply) {
          arrows.push({ type: 'stockfish', thickness: 'reply', from: reply.from, to: reply.to });
        }
      }

      arrows.push({
        type: 'stockfish',
        thickness: i === 0 ? 'primary' : 'secondary',
        from: parsed.from,
        to: parsed.to,
      });
    }

    return arrows;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
